"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DatePicker_meta_1 = require("../DatePicker.meta");
var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");
var rawCssPrefix = "\nalign-items: center;\ndisplay: flex;\njustify-content: space-between;\nmargin-bottom: 16px;\nwidth: 100%;\n";
exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', DatePicker_meta_1.DATE_PICKER_CATEGORY_KEY, DatePicker_meta_1.DATE_PICKER_COMPONENT_KEY, ['header'], rawCssPrefix);
